import axios from 'axios';
import LeadOrigin from '../entity/lead-origin.entity';

export default class LeadOriginService {
  static readonly PATH_URL = '/api/v1/lead-origins';

  public static getLeadOrigins(): Promise<LeadOrigin[]> {
    return axios.get(this.PATH_URL)
      .then((response: any) => LeadOrigin.ofList(response.data));
  }

  public static create(leadOrigin: LeadOrigin): Promise<LeadOrigin> {
    return axios
      .post(this.PATH_URL, leadOrigin)
      .then((response: any) => LeadOrigin.of(response.data));
  }
}
